import Permission from './Permission';

export const PermissionConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path      : '/permission',
            component : Permission,
            permission: { component_name: 'permission', permission_type: 'edit' },
        },
    ]
};



// WEBPACK FOOTER //
// src/main/content/permission/PermissionConfig.js